import HeroSection from './components/HeroSection';
import TrustStats from './components/TrustStats';
import CoreCapabilities from './components/CoreCapabilities';
import CodeChainFlow from './components/CodeChainFlow';
import PartnerBrands from './components/PartnerBrands';
import SuccessCases from './components/SuccessCases';
import HomeCTA from './components/HomeCTA';

export default function Home() {
  return (
    <main>
      <HeroSection />
      <TrustStats />
      <CoreCapabilities />
      <CodeChainFlow />
      <PartnerBrands />
      <SuccessCases />
      <HomeCTA />
    </main>
  );
}